import React from 'react';
import './NumericKeypad.css';

const NumericKeypad = ({ onKeyPress, onDelete, onClear }) => {
    const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

    return (
        <div className="numeric-keypad">
            <div className="keypad-grid">
                {numbers.map((number) => (
                    <button
                        key={number}
                        className="keypad-button"
                        onClick={() => onKeyPress(number)}
                    >
                        {number}
                    </button>
                ))}
                <button
                    className="keypad-button delete"
                    onClick={onDelete}
                >
                    ←
                </button>
                <button
                    className="keypad-button clear"
                    onClick={onClear}
                >
                    C
                </button>
            </div>
        </div>
    );
};

export default NumericKeypad; 